import { PUSH_ON, PUSH_OFF } from './types'

export const turnPushOn = payload => ({
  type: PUSH_ON,
})
export const turnPushOff = payload => ({
  type: PUSH_OFF,
})
